import { UserByInstallationDto } from '../dto/users-by-instalation-dto'
import { UserByInstallationModel } from '../models/users-by-installation-model'

/**
 * Function for transforming user by installation dto to UserByInstallationModel
 * @param users - as array of UserByInstallationDto or undefined
 * @returns array of UserByInstallationModel
 */
export const usersByInstallationTransformer = (users: UserByInstallationDto[] | undefined): UserByInstallationModel[] => {
  return users
    ? users
        .map((user: UserByInstallationDto) => {
          return {
            userId: user.userId || '',
            name: user ? setFullName(user.firstName, user.lastName) : '',
          }
        })
        .sort((userA, userB) => userA.name.localeCompare(userB.name))
    : []
}

const setFullName = (firstName: string | undefined, lastName: string | undefined): string => {
  const fullName = `${firstName} ${lastName}`

  return fullName.trim()
}
